import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/core/_config/app.config';
import { ResponseCustom } from 'src/app/models/ResponseCustom';

@Injectable({
    providedIn: 'root',
})
export class CollectorFileImportService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig) {}

    postFile(formData: FormData) {
        return this.http.post<ResponseCustom>(`${this.API_URL}CollectorFile`, formData);
    }
}
